<template>
  <button class="button--primary">
    <slot />
    <fa-icon :icon="['far', 'plus']" />
  </button>
</template>
